// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditPopup_deleteButton__hkpX5","field":"EditPopup_field__1KRtD","text":"EditPopup_text__gWK-P"};